import * as IoC from 'typescript-ioc';
import { IApiClient } from '../../infrastructure/api-client';
import * as ACCOUNT_USERS_API from '../../constants/api/account-users.constants';
import { IAccountUsersDAO, IAccountUsersListDTOInternal } from '../account-users.dao';

interface IGetUsersParams {
    query?: string;
    page?: number;
    size?: number;
}

class AccountUsersDAO extends IAccountUsersDAO {
    constructor(@IoC.Inject private readonly apiClient: IApiClient) {
        super();
    }

    public async getAccountUsers(params: IGetUsersParams & { accountId: number}): Promise<IAccountUsersListDTOInternal> {
        const response = await this.apiClient.get<IAccountUsersListDTOInternal>(ACCOUNT_USERS_API.ACCOUNT_USERS_LIST_URL, params || {});
        return response.parsedResponse;
    }

    public async getAccountUsersCSV(params: { accountId: number}): Promise<void> {
        await this.apiClient.getFile(ACCOUNT_USERS_API.ACCOUNT_USERS_EXPORT_URL, params);
    }
}

export { AccountUsersDAO };